import { render, staticRenderFns } from "./RetailersGroup.vue?vue&type=template&id=9956f188"
import script from "./RetailersGroup.vue?vue&type=script&lang=js"
export * from "./RetailersGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports